import React, { createContext, useContext, useState } from 'react';
import { BASE_URL, CDN_URL } from '../config/apiconfig';

const TransactionsContext = createContext();

const API_URL = `${BASE_URL}/transactions`;
const PRODUCT_IMAGE_PATH = 'uploads/products/';
const USER_IMAGE_PATH = 'uploads/users/';

export const TransactionsProvider = ({ children }) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTransactions = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token not found');

      const res = await fetch(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });

      const json = await res.json();

      const mapped = (json.data || []).map((o) => ({
        id: o.id,
        transactionId: o.transaction_id,
        orderId: o.order_id,
        amount: Number(o.total),
        fees: Number(o.tax || 0),
        status: o.payment_status?.toLowerCase(),
        paymentMethod: o.payment_method?.toLowerCase(),
        paymentDetails: o.payment_gateway,
        gateway: o.payment_gateway,
        gatewayTransactionId: o.transaction_id,
        date: o.placed_audit_time,

        customer: {
          id: o.user?.id,
          name: `${o.user?.first_name || ''} ${o.user?.last_name || ''}`.trim(),
          email: o.user?.email,
          phone: o.user?.phone,
          avatar: o.user?.image
            ? `${CDN_URL}/${o.user.image}`
            : null,
        },

        billingAddress: {
          name: `${o.user?.first_name || ''} ${o.user?.last_name || ''}`.trim(),
          street: o.address?.street,
          city: o.address?.city,
          state: o.address?.state,
          zipCode: o.address?.zipcode,
          country: o.address?.country_id,
        },

        orderItems: (o.items || []).map((i) => ({
          name: i.product?.product_name,
          quantity: i.quantity,
          price: Number(i.price),
          image: i.product?.product_images
            ? `${CDN_URL}/${JSON.parse(i.product.product_images)[0]}`
            : null,
        })),

        timeline: [
          {
            status: 'placed',
            description: 'Order placed',
            date: o.placed_audit_time,
          },
          o.shipped_audit_time && {
            status: 'shipped',
            description: 'Order shipped',
            date: o.shipped_audit_time,
          },
          o.delivered_audit_time && {
            status: 'delivered',
            description: 'Order delivered',
            date: o.delivered_audit_time,
          },
        ].filter(Boolean),
      }));

      setTransactions(mapped);
    } catch (err) {
      console.error('Fetch transactions error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <TransactionsContext.Provider
      value={{
        transactions,
        loading,
        fetchTransactions,
      }}
    >
      {children}
    </TransactionsContext.Provider>
  );
};

export const useTransactions = () => useContext(TransactionsContext);
